import clsx from 'clsx'
import type { default as React, FunctionComponent } from 'react'
import style from './SimpleSwiper.module.sass'

type SimpleSwiperProps = {
	isTransparent?: boolean
	children: React.ReactNode
}

export const SimpleSwiper: FunctionComponent<SimpleSwiperProps> = ({ children, isTransparent = false }) => {
	return (
		<div className={style.container}>
			<div className={clsx(style.Items, isTransparent && style.transparentScrollBar)}>
				<div className={style.ItemsCarousel}>
					<div className={style.Catch} />
					{children}
					<div className={style.Catch} />
				</div>
			</div>
		</div>
	)
}
